<template>
  <div v-if="0 < categories.length" class="container area_category">
    <h2 class="garally_title text-center">
      <LabelFunMessage fcontId="0" msgkey="53" />
    </h2>
    <CategoryTiles />
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
import CategoryTiles from "./CategoryTiles";

export default {
  name: "GalleryCategory",
  components: {
    CategoryTiles,
    LabelFunMessage,
  },
  computed: {
    ...mapState(["categories"]),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.area_category {
  margin-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
}
.area_category a:hover {
  text-decoration: none;
}
</style>